import { atomWithReset } from "jotai/utils";
export const loadDateAtom = atomWithReset(null);
